module.exports = __webpack_public_path__ + "static/media/lizhi.818b12bb.png";